import { backendApi } from "src/backendApi/backendApi";
import {
  useMutation,
  queryOptions,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";
//
import type { V3Account } from "@neuromotion-inc/mightier-ts-sdk";

export const retrieveAccountQueryOpts = (
  accountId: number,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) => {
  return queryOptions({
    queryKey: ["accounts", "retrieve", accountId],
    queryFn: async () => {
      const resp = await backendApi.retrieveAccount(accountId);
      return resp.data;
    },
  });
};

interface SetAccountPlayerLimitVars {
  accountId: number;
  playerLimit: number | null;
}

type SetAccountPlayerLimitMutRes = UseMutationResult<
  V3Account,
  unknown,
  SetAccountPlayerLimitVars
>;

export const useSetAccountPlayerLimitMutation =
  (): SetAccountPlayerLimitMutRes => {
    const qc = useQueryClient();

    return useMutation({
      mutationFn: async (variables: SetAccountPlayerLimitVars) => {
        const { accountId, playerLimit } = variables;
        const resp = await backendApi.setAccountPlayerLimit(
          accountId,
          playerLimit,
        );
        return resp.data;
      },
      onSuccess: async (data, vars) => {
        const queryKey = retrieveAccountQueryOpts(data.id).queryKey;
        await qc.invalidateQueries({ queryKey });
      },
    });
  };
